var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Text from "../text/Text";
import Box from "../box/Box";
export default (function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? "black" : _b, as = _a.as, to = _a.to, href = _a.href, target = _a.target, textProps = _a.textProps, rest = __rest(_a, ["children", "color", "as", "to", "href", "target", "textProps"]);
    var linkProps = {};
    if (href) {
        linkProps = {
            href: href,
            target: target,
            as: "a",
        };
    }
    else if (to) {
        linkProps = {
            as: as,
            to: to,
        };
    }
    return (React.createElement(Box, __assign({ display: "flex", alignItems: "flex-start" }, rest),
        React.createElement(Box, { bg: color, height: "2px", width: "12%", minWidth: "80px", maxWidth: "160px", mt: "0.65em", mr: 4 }),
        React.createElement(Text, __assign({ typeStyle: "copy03", color: color }, linkProps, textProps, { style: { textDecoration: "none" }, lineHeight: "1.15" }), children)));
});
//# sourceMappingURL=LeftLineCTA.js.map